import './about-page.css'
const AboutPage = () => {
    return (
        <div className='about-page-container'>
            <p>Create with love by <a target='_blank' href="https://www.linkedin.com/in/%C8%99tefan-secrieru-b0b60b224/">Stefan Secrieru</a></p>
            <h2>Features of the app:</h2>
            <ul>
                <li>Add items to cart.</li>
                <li>Cart dropdown.</li>
                <li>Checkout page.</li>
                <li>Change quantity of items in the checkout page.</li>
                <li>Real time calculations regarding your total.</li>
                <li>Add items to favourites.</li>
                <li>Add reviews to items.</li>
                <li>Real time calculations regarding the median value of the reviews.</li>
                <li>Account creation and log in.</li>
                <li>Persisting data such as: favourites and reviews.</li>
                <li>Profile page.</li>
                <li>Pop ups to confirm actions.</li>
                <li>Cute animations.</li>
                <li>Log in and sign-up using Google.</li>
                <li>Sort items by price.</li>
                <li>Search items by name in real time.</li>
            </ul>
        </div>
    )
}

export default AboutPage